module.exports = __webpack_public_path__ + "img/evaluate.4e2f905a.png";